<template>
  <section class="integral-index-container">
    <el-main>
        <el-tabs v-model="activeTabName" @tab-click="handleClick">
          <el-tab-pane label="投稿" name="contributeform">
              <base-form class="tabs-froms"
                v-bind="contributeform"
                :formItems="contributeFormItems"
                v-on:handleConfirm="handleConfirm"
              ></base-form>
          </el-tab-pane>
          <el-tab-pane label="评论" name="commentform">
              <base-form class="tabs-froms"
                v-bind="commentform"
                :formItems="commentFormItems"
                v-on:handleConfirm="handleConfirm"
              ></base-form>
          </el-tab-pane>
          <el-tab-pane label="注册" name="registerform">
              <base-form class="tabs-froms"
                v-bind="registerform"
                v-on:handleConfirm="handleConfirm"
              ></base-form>
          </el-tab-pane>
          <el-tab-pane label="完善信息" name="messageform">
              <base-form class="tabs-froms"
                v-bind="messageform"
                v-on:handleConfirm="handleConfirm"
              ></base-form>
          </el-tab-pane>
        </el-tabs>
      </el-main>
  </section>
</template>

<script>
import baseForm from '@/components/mixins/baseForm'

export default {
  name: 'vipIntegral',
  mixins: [baseForm],
  data () {
    return {
      contributeform: {
        params: {
          code: 'QQ'
        },
        labelWidth: '236px',
        form: {
        },
        rules: {
          submitOnedayMaxScore: [this.$rules.required(), this.$rules.number()],
          submitScoreLimit: [this.$rules.required()],
          submitSuccessScore: [this.$rules.required(), this.$rules.number()],
          submitSuccessNumber: [this.$rules.required(), this.$rules.number()],
          submitStatus: [this.$rules.required()]
        },
        submitBtns: [{
          text: '保存',
          subType: 'submit',
          disabled: !this._checkPermission('/admin/members/score', 'POST')
        }]
      },
      commentform: {
        params: {

        },
        labelWidth: '236px',
        form: {
        },
        rules: {
          commentOnedayMaxScore: [this.$rules.required(), this.$rules.number()],
          commentScoreLimit: [this.$rules.required()],
          commentSuccessScore: [this.$rules.required(), this.$rules.number()],
          commentSuccessNumber: [this.$rules.required(), this.$rules.number()],
          commentStatus: [this.$rules.required()]
        },
        submitBtns: [{
          text: '保存',
          subType: 'submit',
          disabled: !this._checkPermission('/admin/members/score', 'POST')
        }]
      },
      registerform: {
        params: {
        },
        labelWidth: '236px',
        form: {
        },
        formItems: [
          {
            type: 'switch',
            prop: 'registerStatus',
            label: '状态：',
            activeValue: '1',
            inactiveValue: '0'
          },
          {
            type: 'number',
            prop: 'registerSuccessScore',
            label: '注册成功获取积分：',
            appendText: '需输入大于0的整数',
            min: 1,
            maxlength: 11
          }
        ],
        rules: {
          registerStatus: [this.$rules.required()],
          registerSuccessScore: [this.$rules.required(), this.$rules.number()]
        },
        submitBtns: [{
          text: '保存',
          subType: 'submit',
          disabled: !this._checkPermission('/admin/members/score', 'POST')
        }]
      },
      messageform: {
        params: {
        },
        labelWidth: '236px',
        form: {
        },
        formItems: [
          {
            type: 'switch',
            prop: 'perfectMessageStatus',
            label: '状态：',
            activeValue: '1',
            inactiveValue: '0'
          },
          {
            type: 'number',
            prop: 'perfectMessageSuccessScore',
            label: '完善个人信息获得积分：',
            appendText: '需输入大于0的整数',
            min: 1,
            maxlength: 11
          }
        ],
        rules: {
          perfectMessageStatus: [this.$rules.required()],
          perfectMessageSuccessScore: [this.$rules.required(), this.$rules.number()]
        },
        submitBtns: [{
          text: '保存',
          subType: 'submit',
          disabled: !this._checkPermission('/admin/members/score', 'POST')
        }]
      },
      activeTabName: 'contributeform'
    }
  },
  computed: {
    contributeFormItems () {
      return [
        {
          type: 'switch',
          prop: 'submitStatus',
          label: '状态：',
          activeValue: '1',
          inactiveValue: '0'
        },
        {
          type: 'number',
          prop: 'submitSuccessNumber',
          label: '每成功投稿：',
          appendText: '需输入大于0的整数',
          unit: '篇',
          min: 1,
          maxlength: 11
        },
        {
          type: 'number',
          prop: 'submitSuccessScore',
          label: '获得积分：',
          appendText: '需输入大于0的整数',
          min: 1,
          max: this.contributeform.form.submitOnedayMaxScore,
          maxlength: 11
        },
        {
          type: 'radio',
          prop: 'submitScoreLimit',
          label: '积分获取限制：',
          options: [
            {
              value: '1',
              label: '开启'
            },
            {
              value: '0',
              label: '不开启'
            }
          ]
        },
        {
          type: 'number',
          prop: 'submitOnedayMaxScore',
          label: '每日投稿最多可获取积分：',
          appendText: '需输入大于0的整数',
          hiddenKey: 'submitScoreLimit',
          hiddenValue: '1',
          min: this.contributeform.form.submitSuccessScore || 1,
          maxlength: 11
        }
      ]
    },
    commentFormItems () {
      return [
        {
          type: 'switch',
          prop: 'commentStatus',
          label: '状态：',
          activeValue: '1',
          inactiveValue: '0'
        },
        {
          type: 'number',
          prop: 'commentSuccessNumber',
          label: '每成功评论：',
          appendText: '需输入大于0的整数',
          unit: '次',
          min: 1,
          maxlength: 11
        },
        {
          type: 'number',
          prop: 'commentSuccessScore',
          label: '获得积分：',
          appendText: '需输入大于0的整数',
          min: 1,
          max: this.commentform.form.commentOnedayMaxScore,
          maxlength: 11
        },
        {
          type: 'radio',
          prop: 'commentScoreLimit',
          label: '积分获取限制：',
          options: [
            {
              value: '1',
              label: '开启'
            },
            {
              value: '0',
              label: '不开启'
            }
          ]
        },
        {
          type: 'number',
          prop: 'commentOnedayMaxScore',
          label: '每日评论最多可获取积分：',
          appendText: '需输入大于0的整数',
          hiddenKey: 'commentScoreLimit',
          hiddenValue: '1',
          min: this.commentform.form.commentSuccessScore || 1,
          maxlength: 11
        }
      ]
    }
  },
  methods: {
    handleConfirm (data) {
      this.$request.fetchMembersScoreAlter(data).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
        }
      }).catch()
    },
    handleClick (tab, event) {
      this.fetchMembersScoreDetail()
    },
    fetchMembersScoreDetail () {
      this.$request.fetchMembersScoreDetail().then(res => {
        if (res.code === 200) {
          if (this.activeTabName === 'contributeform') {
            this.contributeform.form = res.data.cmsSiteCfg
          } else if (this.activeTabName === 'commentform') {
            this.commentform.form = res.data.cmsSiteCfg
          } else if (this.activeTabName === 'registerform') {
            this.registerform.form = res.data.cmsSiteCfg
          } else if (this.activeTabName === 'messageform') {
            this.messageform.form = res.data.cmsSiteCfg
          }
        }
      }).then(this.hideTableLoading).catch(this.hideTableLoading)
    }
  },
  mounted () {
    this.fetchMembersScoreDetail()
  },
  created () {

  }
}
</script>

<style lang="scss" scoped>

</style>
